import React, { useEffect, useState } from "react";
import { Loader2, CheckCircle, AlertTriangle } from "lucide-react";
import { acceptCollaborationInvite } from "../api";

const PENDING_CASE_KEY = "cm_pending_case_id";

const CollaborationInviteAccept = () => {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Accepting your invite...");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Missing invite token. Please check your link.");
      return;
    }

    let isActive = true;
    acceptCollaborationInvite(token)
      .then((response) => {
        if (!isActive) return;
        const payload = response?.data?.data || response?.data || response || {};
        const caseId = payload.caseId || payload.case_id || payload.id || "";
        if (caseId) {
          window.localStorage.setItem(PENDING_CASE_KEY, caseId);
        }
        setStatus("success");
        setMessage("Invite accepted. Redirecting to your dashboard...");
        setTimeout(() => {
          window.location.href = "/";
        }, 800);
      })
      .catch((error) => {
        if (!isActive) return;
        setStatus("error");
        setMessage(error?.message || "Unable to accept invite.");
      });

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="min-h-screen dark:bg-slate-950 bg-slate-50 dark:text-slate-100 text-slate-900 flex items-center justify-center px-6">
      <div className="max-w-md w-full dark:bg-slate-900 bg-white border dark:border-slate-800 border-slate-200 rounded-2xl p-6 text-center space-y-4 shadow-xl">
        {status === "loading" && <Loader2 className="w-8 h-8 dark:text-sky-400 text-sky-600 animate-spin mx-auto" />}
        {status === "success" && <CheckCircle className="w-8 h-8 dark:text-emerald-400 text-emerald-600 mx-auto" />}
        {status === "error" && <AlertTriangle className="w-8 h-8 dark:text-amber-400 text-amber-600 mx-auto" />}
        <h1 className="text-xl font-semibold dark:text-white text-slate-900">Collaboration Invite</h1>
        <p className="text-sm text-slate-500">{message}</p>
        {status === "error" && (
          <button
            onClick={() => (window.location.href = "/")}
            className="mt-2 px-4 py-2 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-500 transition-colors"
          >
            Go to login
          </button>
        )}
      </div>
    </div>
  );
};

export default CollaborationInviteAccept;
